import universal from 'react-universal-component';

export default universal(() => import('./Season'));



// WEBPACK FOOTER //
// ./src/app/views/Season/index.js